
export const deTranslations = {
    // Header
    'nav.home': 'Startseite',
    'nav.services': 'Dienstleistungen',
    'nav.products': 'Produkte',
    'nav.customization': 'Individualisierung',
    'nav.superSupport': 'Super Support',
    'nav.about': 'Über Uns',
    'nav.team': 'Team',
    'nav.blog': 'Blog',
    
    // Customization Section
    'customization.title': 'Individuelle Erweiterungen',
    'customization.subtitle': 'Wir entwickeln, was Ihnen fehlt',
    'customization.intro1': 'Unsere Software deckt bereits die wichtigsten Prozesse ab. Doch jedes Unternehmen hat eigene Anforderungen – und genau dafür bieten wir Individualisierung an.',
    'customization.intro2': 'Wir entwickeln individuelle Funktionen, Module und Integrationen, die exakt auf Ihre Bedürfnisse zugeschnitten sind. Schnell, professionell und vollständig in Ihr System integriert.',
    'customization.intro3': 'Ob kleiner Zusatz oder grosses neues Modul – wir sorgen dafür, dass Ihre Software exakt zu Ihrem Unternehmen passt.',
    'customization.whatWeCanDo': 'Was wir für Sie erweitern oder entwickeln können',
    'customization.individualFunctions': 'Individuelle Funktionen',
    'customization.newModules': 'Neue Module und Abläufe',
    'customization.processExtensions': 'Erweiterungen bestehender Prozesse',
    'customization.automations': 'Automatisierungen',
    'customization.workflows': 'Individuelle Workflows',
    'customization.notifications': 'Benachrichtigungssysteme',
    'customization.dataValidation': 'Datenvalidierung & Prüfungen',
    'customization.interfaces': 'Schnittstellen & Integrationen',
    'customization.apiConnections': 'API-Anbindungen',
    'customization.paymentIntegrations': 'Zahlungsintegrationen',
    'customization.accessIntegrations': 'Zutritts- oder Hardware-Integrationen',
    'customization.thirdPartySystems': 'Systeme von Drittanbietern',
    'customization.cloudServices': 'Cloud-Services Anbindung',
    'customization.dataSync': 'Datensynchronisation',
    'customization.designUi': 'Design & Benutzeroberfläche',
    'customization.individualLayouts': 'Individuelle Layouts oder UI-Anpassungen',
    'customization.documentLayouts': 'Eigene Dokument- und Rechnungslayouts',
    'customization.brandingDesign': 'Branding und Corporate Design',
    'customization.mobileOptimization': 'Mobile Optimierung',
    'customization.accessibilityFeatures': 'Barrierefreiheit',
    'customization.darkMode': 'Dark Mode & Themes',
    'customization.reportsAnalytics': 'Reports & Auswertungen',
    'customization.individualStats': 'Individuelle Statistiken und Exporte',
    'customization.dashboardCharts': 'Erweiterte Dashboard-Charts',
    'customization.specialReports': 'Spezialberichte und Analysen',
    'customization.scheduledReports': 'Automatisierte Berichte',
    'customization.dataExports': 'Datenexporte (CSV, PDF, Excel)',
    'customization.kpiTracking': 'KPI-Tracking & Kennzahlen',
    'customization.whyCustomersLove': 'Warum Kunden unsere Erweiterungen lieben',
    'customization.individual': 'Individuell',
    'customization.individualDesc': 'exakt auf Ihre Prozesse abgestimmt',
    'customization.seamless': 'Nahtlos integriert',
    'customization.seamlessDesc': 'wirkt wie ein natürlicher Teil des Systems',
    'customization.fastImplementation': 'Schnelle Umsetzung',
    'customization.fastImplementationDesc': 'direkte Abstimmung & kurze Wege',
    'customization.professional': 'Professionell dokumentiert',
    'customization.professionalDesc': 'sauberer, wartbarer Code',
    'customization.futureProof': 'Zukunftssicher',
    'customization.futureProofDesc': 'kompatibel mit künftigen Updates',
    'customization.howItWorks': 'So läuft eine Erweiterung ab',
    'customization.step1Title': 'Anforderungsgespräch',
    'customization.step1Desc': 'Sie erklären, was Sie benötigen – wir beraten Sie technisch.',
    'customization.step2Title': 'Angebot & Aufwandsschätzung',
    'customization.step2Desc': 'Transparent und nachvollziehbar.',
    'customization.step3Title': 'Umsetzung & Einrichtung',
    'customization.step3Desc': 'Entwicklung, Test, Integration und Übergabe.',
    'customization.step4Title': 'Betreuung & Weiterentwicklung',
    'customization.step4Desc': 'Wartung und weitere Anpassungen.',
    'customization.ctaTitle': 'Wir entwickeln, was Ihnen fehlt',
    'customization.ctaDesc': 'Ob kleiner Zusatz oder grosses neues Modul – wir sorgen dafür, dass Ihre Software exakt zu Ihrem Unternehmen passt.',
    'customization.ctaButton': 'Kontaktieren Sie uns für ein individuelles Angebot',
    
    // Super Support Section
    'superSupport.title': 'Super Support',
    'superSupport.subtitle': 'Wir sind für Sie da – persönlich, schnell und kompetent',
    'superSupport.intro1': 'Software ist nur so gut wie der Support dahinter. Bei Initso erhalten Sie keinen anonymen Standard-Support, sondern echte Expertenhilfe, wann immer Sie sie brauchen.',
    'superSupport.intro2': 'Wir begleiten Sie nicht nur bei Problemen – wir denken mit, finden Lösungen und unterstützen Sie aktiv dabei, Ihr Unternehmen effizienter zu machen.',
    'superSupport.whatMakesUsSpecial': 'Was unseren Support aussergewöhnlich macht',
    'superSupport.directContact': 'Direkter Kontakt',
    'superSupport.directContactDesc': 'Keine Callcenter, keine Weiterleitungen – Sie sprechen direkt mit Fachleuten, die das System kennen.',
    'superSupport.fastResponse': 'Schnelle Reaktionszeiten',
    'superSupport.fastResponseDesc': 'Wir beantworten Anfragen in der Regel innerhalb weniger Tagen oder sogar Stunden, je nach Komplexität.',
    'superSupport.proactiveHelp': 'Proaktive Hilfe',
    'superSupport.proactiveHelpDesc': 'Wir melden uns, wenn wir Unregelmässigkeiten erkennen, unterstützen bei Anpassungen und beraten bei Optimierungen.',
    'superSupport.clearSolutions': 'Klare, nachvollziehbare Lösungen',
    'superSupport.clearSolutionsDesc': 'Wir erklären verständlich, lösen Probleme zuverlässig und sorgen dafür, dass alles reibungslos läuft.',
    'superSupport.setupTraining': 'Unterstützung bei Einrichtung & Schulung',
    'superSupport.setupTrainingDesc': 'Wir helfen beim Start, konfigurieren Ihr System und schulen Ihr Team.',
    'superSupport.yourSuccessTitle': 'Ihr Erfolg ist unser Ziel',
    'superSupport.yourSuccessDesc1': 'Mit Initso erhalten Sie nicht nur ein leistungsstarkes System, sondern einen starken Partner an Ihrer Seite.',
    'superSupport.yourSuccessDesc2': 'Wir sorgen dafür, dass Ihr Unternehmen jederzeit professionell unterstützt wird.',
    
    // Hero
    'hero.title': 'Softwareentwicklung, Webentwicklung und IT-Beratung mit Super Support',
    'hero.subtitle': 'Wir helfen Unternehmen, mit Technologie zu transformieren und zu wachsen.',
    'hero.cta': 'Kontakt',
    'hero.professional.initso': 'INITSO',
    'hero.professional.line1': 'Ihr persönlicher IT-Partner',
    'hero.professional.line2': 'in der Schweiz',
    'hero.comprehensive': 'Wir bieten umfassende IT-Lösungen und Dienstleistungen an, um Unternehmen beim Wachstum zu unterstützen, Betriebsabläufe zu optimieren und in der digitalen Welt sicher zu bleiben.',
    'hero.services': 'Unsere Dienstleistungen',
    'hero.contactus': 'Kontaktieren Sie Uns',
    'hero.tryGymSoftware': 'Gym Software ausprobieren',
    // Services
    'services.title': 'Unsere Dienstleistungen',
    'services.description': 'Wir bieten umfassende IT-Lösungen, um Unternehmen in der digitalen Landschaft zu unterstützen. Von strategischer Beratung bis zur technischen Implementierung sind unsere Dienstleistungen darauf ausgerichtet, Ihre Bedürfnisse zu erfüllen.',
    'services.consulting.title': 'IT-Beratung',
    'services.consulting.description': 'Experten-Beratung, um Ihnen bei strategischen Technologieentscheidungen zu helfen, die mit Ihren Unternehmenszielen übereinstimmen.',
    'services.consulting.feature1': 'Technologiebewertung',
    'services.consulting.feature2': 'Digitale Transformation',
    'services.consulting.feature3': 'IT-Strategieplanung',
    'services.consulting.feature4': 'Prozessoptimierung',
    'services.integration.title': 'Systemintegration',
    'services.integration.description': 'Nahtlose Verbindung Ihrer Anwendungen und Systeme zur Verbesserung der Effizienz und des Datenflusses.',
    'services.integration.feature1': 'API-Entwicklung',
    'services.integration.feature2': 'Legacy-System-Integration',
    'services.integration.feature3': 'Cloud-Integrationslösungen',
    'services.integration.feature4': 'Systemarchitektur-Design',
    'services.software.title': 'Massgeschneiderte <br> Software',
    'services.software.description': 'Individuelle Softwarelösungen, die speziell für Ihre einzigartigen Geschäftsanforderungen entwickelt wurden.',
    'services.software.feature1': 'Individuelle Anwendungsentwicklung',
    'services.software.feature2': 'Mobile App-Entwicklung',
    'services.software.feature3': 'Web-Anwendungen',
    'services.software.feature4': 'Software-Wartung',
    'services.support.title': 'Projektmanagement',
    'services.support.description': 'Umfassende Projektmanagement-Dienstleistungen, die speziell auf die Bedürfnisse von Softwareprojekten zugeschnitten sind.',
    'services.support.feature1': 'Kompetente Initiierung',
    'services.support.feature2': 'Strategische Planung',
    'services.support.feature3': 'Effiziente Durchführung',
    'services.support.feature4': 'Erfolgreicher Abschluss',
    // Products
    'products.title': 'Unsere Produkte',
    'products.description': 'Entdecken Sie unsere Suite innovativer Produkte, die entwickelt wurden, um Ihre Geschäftsabläufe und digitale Präsenz zu verbessern.',
    'products.features': 'Hauptmerkmale',
    'products.learnMore': 'Mehr erfahren',
    'products.prop': 'PropertyProfi',
    'products.prop.description': 'Mit cloudbasiertem Tool alle Infos und Aufgaben unter Kontrolle halten',
    'products.gym': 'Gym Management',
    'products.gym.description': 'All-in-one cloudbasierte Gym Management Software.',
    'products.web': 'Webseite',
    'products.web.description': 'Kreative Webdesign-Experten, effizientes Datenmanagement und nahtlose Integration über unsere API',
    'products.portal': 'Kundenportal',
    'products.portal.description': 'Abschlüsse Ihrer Betriebspartner und die Bestellungen der Kunden in einem übersichtlichen, sicheren Cloud Tool',
    // Features
    'feature.individual': 'Individualisierbar',
    'feature.member': 'Mitgliederverwaltung',
    'feature.bill': 'Rechnungsstellung',
    'feature.integration': 'Integrationen',
    'feature.report': 'Berichte',
		'feature.access': 'Zutrittskontrolle',
		
		// Marquee Features
		'feature.memberManagement': 'Mitgliederverwaltung',
		'feature.invoicing': 'Rechnungsstellung',
		'feature.billing595': 'Abrechnung nach Tarif 595',
		'feature.accessControl': 'Zutrittskontrolle',
		'feature.reportGeneration': 'Berichtgenerierung',
		'feature.analytics': 'Analyse',
		'feature.onlineRegistration': 'Online Registrierung',
		'feature.customerCommunication': 'Kundenkommunikation',
		'feature.changeHistory': 'Änderungshistorie',
		'feature.subscriptionManagement': 'Aboverwaltung',
		'feature.subscriptionPause': 'Abo-Pausierung',
		'feature.installmentPayments': 'Ratenzahlungen',
		
		'feature.crm': 'CRM',
		'feature.management': 'Verwaltung der Liegenschaften',
		'feature.accounting': 'Buchhaltung',
		'feature.document': 'Dokumentenarchiv',
		'feature.insurance': 'Versicherungsmanagement',

    'feature.creativ': 'Kreative Responsive Webdesign',
    'feature.custom': 'Massgeschneiderte Homepage-Lösungen',
    'feature.data': 'Effizientes Datenmanagement',
    'feature.api': 'API Anbindungen',
    'feature.responsive': 'Responsive Webdesign',

    'feature.application': 'Effiziente Antragsbearbeitung',
    'feature.visualization': 'Datenvisualisierung',
    'feature.customer': 'Kompetente Kundenbetreuung',
    'feature.productivity': 'Produktivität steigern',
    'feature.scalable': 'Skalierbare Cloud-Architektur',
    'feature.realtime': 'Echtzeit-Kollaborationstools',
    'feature.backup': 'Automatisierte Datensicherung',
    'feature.security': 'Erweiterte Sicherheitsprotokolle',
    'feature.predictive': 'Prädiktive Analysen',
    'feature.reporting': 'Automatisiertes Reporting',
    'feature.kpi': 'Individuelles KPI-Tracking',
    'feature.dataIntegration': 'Datenintegration aus mehreren Quellen',
    'feature.monitoring': 'Echtzeit-Bedrohungsüberwachung',
    'feature.intrusion': 'Systeme zur Angriffserkennung',
    'feature.encryption': 'Datenverschlüsselungsprotokolle',
    'feature.compliance': 'Sicherheits-Compliance-Audits',
    'feature.updates': 'Automatische Sicherheitsupdates',
    'feature.pipelines': 'Automatisierte CI/CD-Pipelines',
    'feature.code': 'Code-Qualitätsmetriken',
    'feature.collaborative': 'Kollaborative Entwicklungsumgebung',
    'feature.version': 'Integration von Versionskontrolle',
    'feature.container': 'Containerisierte Entwicklungsworkflows',

    // About
    'about.title': 'Über Uns',
    'about.description': 'Wir sind ein Team engagierter Fachleute, die sich der Bereitstellung aussergewöhnlicher IT-Lösungen verschrieben haben.',
    'about.aboutinitso': 'Über INITSO',
    'about.leadingprovider': 'INITSO ist ein Kundenorientierter IT-Dienstleister mit Sitz in der Schweiz, der sich der Bereitstellung hochwertiger Technologielösungen für Unternehmen aller Grössen widmet.',
    'about.experience': 'Mit jahrelanger Erfahrung und einem Team von qualifizierten Fachleuten bieten wir umfassende IT-Dienstleistungen von der Beratung und Entwicklung bis hin zur Wartung und Support. Unser Fokus liegt auf der Erstellung massgeschneiderter Lösungen, die auf spezifische Geschäftsanforderungen eingehen und Wachstum fördern.',
    'about.mission': 'Unsere Mission',
    'about.mission.description': 'Unternehmen durch innovative Technologielösungen zu stärken.',
    'about.vision': 'Unsere Vision',
    'about.vision.description': 'Der vertrauenswürdige Technologiepartner für Unternehmen in der ganzen Schweiz zu sein.',
    'about.quality': 'Qualität',
    'about.quality.description': 'Wir setzen auf höchste Qualitätsstandards in allen unseren Projekten und Lösungen, um nachhaltige Ergebnisse für unsere Kunden zu erzielen. Jedes Detail wird sorgfältig geprüft und optimiert, damit unsere Lösungen nicht nur funktional, sondern auch zuverlässig und zukunftssicher sind.',
    'about.innovation': 'Innovation',
    'about.innovation.description': 'Moderne Technologien und kreative Ansätze ermöglichen es uns, innovative Lösungen für die Herausforderungen unserer Kunden zu entwickeln. Wir bleiben stets am Puls der Zeit und integrieren neueste Entwicklungen in unsere Arbeit, um massgeschneiderte Lösungen zu schaffen.',
   // Testimonials
	 'testimonials.title': 'Testimonials',
		// Contact
    'contact.title': 'Kontaktieren Sie Uns',
    'contact.description': 'Bereit, Ihr Unternehmen mit Technologie zu transformieren? Nehmen Sie Kontakt mit unserem Team auf.',
    'contact.form.name': 'Ihr Name',
    'contact.form.email': 'Ihre E-Mail',
    'contact.form.message': 'Ihre Nachricht',
    'contact.messagePlaceholder': 'Bitte nehmen Sie mit mir Kontakt auf.',
    'contact.form.submit': 'Nachricht senden',
    'contact.sending': 'Senden...',
    'contact.info.address': 'Adresse',
    'contact.info.email': 'E-Mail',
    'contact.info.phone': 'Telefon',
		'contact.messageSent':'Nachricht gesendet',
		'contact.thankYou':"Vielen Dank, dass Sie mit uns Kontakt aufgenommen haben. Wir werden uns bald wieder bei Ihnen melden!",
		'contact.error':'Fehler',
		'contact.errorMessage':'Beim Senden Ihrer Nachricht ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
		'contact.contactInfo': 'Kontakt Informationen',
		'contact.businessHours': 'Öffnungszeiten',
		'contact.businessHoursValue': '09:00-18:00 Uhr',
		'contact.weekdays': 'Wochentags',
		'contact.weekend': 'Wochenende',
		'contact.closed': 'Geschlossen',
    // Footer
    'footer.newsletter': 'Abonnieren Sie unseren Newsletter für Updates und Einblicke.',
    'footer.subscribe': 'Abonnieren',
    'footer.rights': 'Alle Rechte vorbehalten.',
    'footer.services': 'Dienstleistungen',
    'footer.itconsulting': 'IT-Beratung',
    'footer.systemintegration': 'Systemintegration',
    'footer.customsoftware': 'Massgeschneiderte Software',
    'footer.itsupport': 'Projektmanagement',
    'footer.cloudservices': 'Cloud-Dienste',
    'footer.company': 'Unternehmen',
    'footer.aboutus': 'Über Uns',
    'footer.careers': 'Karriere',
    'footer.blog': 'Blog',
    'footer.privacy': 'Datenschutzrichtlinie',
    'footer.terms': 'Nutzungsbedingungen',
    'footer.youremail': 'Ihre E-Mail',
		'footer.error': "Fehler",
		'footer.validEmail': 'Bitte geben Sie eine gültige E-Mail ein',
		'footer.subscribed': "Abonniert!",
    'footer.thankYou':"Vielen Dank, dass Sie unseren Newsletter abonniert haben.",
		'footer.errorMessage':"Es gab ein Problem mit Ihrem Abonnement. Bitte versuchen Sie es erneut.",
    // Product Detail Pages - Gym
    'gym.title': 'Gym Management',
    'gym.subtitle': 'All-in-one Gym Management Software: 100% cloudbasiert, sofort startklar auf Windows, Apple und Android.',
    'gym.heroIntro': 'All-in-one Gym Management Software',
    'gym.cloudBased': '100% cloudbasiert',
    'gym.readyOn': 'sofort startklar auf',
    'gym.backToOverview': 'Zurück zur Übersicht',
    'gym.navFeatures': 'Hauptfunktionen',
    'gym.navShowcase': 'Einblick',
    'gym.navPricing': 'Preisgestaltung',
    'gym.navAllFeatures': 'Alle Funktionen',
    'gym.navWhyUs': 'Warum wir',
    'gym.mainFeatures': 'Hauptfunktionen',
    'gym.featuresDescription': 'Unsere Gym Management Software bietet alle Funktionen, die Sie für die erfolgreiche Führung Ihres Fitnessstudios benötigen - inklusive Abrechnung nach Tarif 595.',
    'gym.customizable': 'Individualisierbar',
    'gym.customizableDesc': 'Passen Sie die Software ganz nach Ihren Bedürfnissen an. Flexible Konfiguration für jede Art von Fitnessstudio.',
    'gym.memberManagement': 'Mitgliederverwaltung',
    'gym.memberManagementDesc': 'Komplette Verwaltung Ihrer Mitglieder mit Profilen, Verträgen, Trainingshistorie und persönlichen Daten.',
    'gym.invoicing': 'Rechnungsstellung',
    'gym.invoicingDesc': 'Automatische Rechnungserstellung und Zahlungsabwicklung mit verschiedenen Zahlungsmethoden und Erinnerungen.',
    'gym.billing595': 'Abrechnung nach Tarif 595',
    'gym.billing595Desc': 'Erstellen Sie Rückforderungsbelege nach Tarif 595 direkt in Ihrem System – ohne Medienbruch oder externe Tools. Ab 01.01.2027 automatisch freigeschaltet.',
    'gym.billing595ImageAlt': 'Rechnungsansicht für Abrechnung nach Tarif 595 in der Gym Management Software',
    'gym.onlineRegistrationImageAlt': 'Online Registrierung in der Gym Management Software',
    'gym.memberManagementImageAlt': 'Mitgliederverwaltung in der Gym Management Software',
    'gym.invoicingImageAlt': 'Rechnungsstellung in der Gym Management Software',
    'gym.billing595FeatureImageAlt': 'Abrechnung nach Tarif 595 in der Gym Management Software',
    'gym.integrationsImageAlt': 'Integrationen in der Gym Management Software',
    'gym.reportsImageAlt': 'Berichte und Analytics in der Gym Management Software',
    'gym.accessControlImageAlt': '24/7 Zutrittskontrolle in der Gym Management Software',
    'gym.customizableImageAlt': 'Individualisierbare Gym Management Software',
    'gym.subscriptionManagementImageAlt': 'Aboverwaltung in der Gym Management Software',
    'gym.customerCommunicationImageAlt': 'Kundenkommunikation in der Gym Management Software',
    'gym.integrations': 'Integrationen',
    'gym.integrationsDesc': 'Nahtlose Integration mit bestehenden Systemen und Equipment für ein einheitliches Erlebnis.',
    'gym.reports': 'Berichte',
    'gym.reportsDesc': 'Umfassende Berichte und Analysen zu Mitgliederzahlen, Umsatz, Auslastung und vielen weiteren KPIs.',
    'gym.accessControl': '24/7 Zutrittskontrolle',
    'gym.accessControlDesc': 'Moderne Zutrittskontrolle mit digitalen Mitgliedskarten und automatischer Anwesenheitserfassung.',
    'gym.onlineRegistration': 'Online Registrierung',
    'gym.onlineRegistrationDesc': 'Ermöglichen Sie Ihren Mitgliedern die bequeme Online-Registrierung rund um die Uhr - schnell, einfach und sicher.',
    'gym.subscriptionManagement': 'Aboverwaltung',
    'gym.subscriptionManagementDesc': 'Verwalten Sie alle Abonnements zentral - von Vertragsänderungen bis zu automatischen Verlängerungen und Kündigungen.',
    'gym.customerCommunication': 'Kundenkommunikation',
    'gym.customerCommunicationDesc': 'Bleiben Sie mit Ihren Mitgliedern in Kontakt durch integrierte Kommunikationstools für Newsletter, Benachrichtigungen und persönliche Nachrichten.',
    'gym.showcaseTitle': 'Gym Management Einblick',
    'gym.showcase1Title': 'Mitgliederverwaltung',
    'gym.showcase1Desc': 'Mit unserer intuitiven Kundenübersicht behalten Sie alle wichtigen Informationen zu Ihren Kunden stets im Blick. Durch schnelle und präzise Suchfunktionen finden Sie im Handumdrehen, was Sie brauchen.',
    'gym.showcase2Title': 'Online Registrierung',
    'gym.showcase2Desc': 'Registrieren Sie neue Mitglieder und Interessenten flexibel online oder direkt vor Ort. Ob per Laptop, Tablet oder Smartphone – die Anmeldung ist kinderleicht und von überall möglich.',
    'gym.showcase3Title': 'Reporting & Analytics',
    'gym.showcase3Desc': 'Detaillierte Berichte und Analysen für bessere Geschäftsentscheidungen und Erfolgsoptimierung. Vereinfachen Sie Ihre Zahlungsabwicklung und gewinnen Sie wertvolle Zeit zurück.',
    'gym.showcase4Title': 'Abrechnung nach Tarif 595',
    'gym.showcase4Desc': 'INITSO bietet Abrechnung nach Tarif 595 als sichtbaren Teil Ihrer digitalen Studioverwaltung an. So behalten Sie Rechnungen, offene Beträge und Zahlungsstatus zentral im Blick.',
    'gym.whyOurSoftware': 'Warum unsere Gym Software?',
    'gym.timeSaving': 'Zeitersparnis',
    'gym.timeSavingDesc': 'Automatisieren Sie wiederkehrende Aufgaben und konzentrieren Sie sich auf das Wesentliche - Ihre Mitglieder.',
    'gym.increasedEfficiency': 'Erhöhte Effizienz',
    'gym.increasedEfficiencyDesc': 'Optimieren Sie Ihre Betriebsabläufe und reduzieren Sie administrativen Aufwand erheblich.',
    'gym.betterMemberExperience': 'Bessere Mitgliedererfahrung',
    'gym.betterMemberExperienceDesc': 'Bieten Sie Ihren Mitgliedern moderne digitale Services und verbessern Sie die Kundenzufriedenheit.',
    'gym.dataBasedDecisions': 'Datenbasierte Entscheidungen',
    'gym.dataBasedDecisionsDesc': 'Treffen Sie fundierte Geschäftsentscheidungen basierend auf aussagekräftigen Daten und Analysen.',
    'gym.readyForFuture': 'Bereit für die Zukunft der Gym-Verwaltung?',
    'gym.readyForFutureDesc': 'Lassen Sie sich von unseren Experten zeigen, wie unsere Gym Management Software Ihr Fitnessstudio revolutionieren kann.',
    'gym.requestDemo': 'Demo anfordern',
    'gym.pricing': 'Preisgestaltung',
    'gym.pricingDesc': 'Faire Preise für jede Studiogrösse - Starten Sie noch heute',
    'gym.pricingTier1': 'Basis',
    'gym.pricingTier1Members': 'Bis 100 Mitglieder',
    'gym.pricingTier2': 'Erweitert',
    'gym.pricingTier2Members': '100 - 500 Mitglieder',
    'gym.pricingTier3': 'Pro',
    'gym.pricingTier3Members': '500 - 1000 Mitglieder',
    'gym.pricingTier4': 'Unternehmen',
    'gym.pricingTier4Members': 'Über 1000 Mitglieder',
    'gym.pricingByAgreement': 'Nach Vereinbarung',
    'gym.pricingPerMonth': 'CHF pro Monat',
    'gym.pricingPrice2': '250 CHF / Monat',
    'gym.pricingPrice3': '350 CHF / Monat',
    'gym.pricingPrice4': '500 CHF / Monat',
    'gym.pricingTerms': 'Automatische Verlängerung.',
    'gym.pricingCancelAnytime': 'Jederzeit kündbar.',
    'gym.pricingPlatforms': 'Verfügbar für',
    'gym.pricingAllFeatures': 'ALLE FEATURES',
    'gym.pricingContactButton': 'Kontaktieren Sie uns',
    'gym.allFeaturesTitle': 'Alle Funktionen',
    'gym.allFeatures1Title': 'Online-Registrierung',
    'gym.allFeatures1Item1': 'Web-Registrierung über Ihre Website',
    'gym.allFeatures1Item2': 'Einzel-, und Paarregistrierung',
    'gym.allFeatures2Title': 'Einstellungen & Systemkonfiguration',
    'gym.allFeatures2Item1': 'Individualisiertes Design',
    'gym.allFeatures2Item2': 'SMTP-Konfiguration',
    'gym.allFeatures2Item3': 'Bankkonto-Einstellungen',
    'gym.allFeatures2Item4': 'Mitarbeiterverwaltung',
    'gym.allFeatures2Item5': 'Abonnement-Konfiguration',
    'gym.allFeatures2Item6': 'Rechnungspositionen',
    'gym.allFeatures2Item7': 'Dokumentenvorlagen',
    'gym.allFeatures2Item8': 'Text- und E-Mail-Vorlagen',
    'gym.allFeatures3Title': 'Dashboard, Analysen & Exporte',
    'gym.allFeatures3Item1': 'Excel-Exporte',
    'gym.allFeatures3Item2': 'Umsatz-, Zahlungs- und Kundencharts',
    'gym.allFeatures3Item3': 'Übersicht ausstehender Zahlungen',
    'gym.allFeatures4Title': 'Mitgliederverwaltung',
    'gym.allFeatures4Item1': 'Mitgliederliste mit Filteroptionen',
    'gym.allFeatures4Item2': 'Manuelle Mitgliedererstellung',
    'gym.allFeatures4Item3': 'Detailansicht mit Abonnements, Rechnungen, Zahlungen und Dokumenten',
    'gym.allFeatures4Item4': 'Änderungshistorie',
    'gym.allFeatures5Title': 'Abo- / Vertragsverwaltung',
    'gym.allFeatures5Item1': 'Automatische und manuelle Vertragserstellung mit E-Mail',
    'gym.allFeatures5Item2': 'Automatische und manuelle Rechnungsstellung',
    'gym.allFeatures5Item3': 'Statusänderungen',
    'gym.allFeatures5Item4': 'Pausierungsoptionen mit automatischer Verlängerung',
    'gym.allFeatures6Title': 'Rechnungswesen',
    'gym.allFeatures6Item1': 'Kunden- und globale Rechnungstabellen',
    'gym.allFeatures6Item2': 'Manuelle/automatische Rechnungsstellung mit Versand',
    'gym.allFeatures6Item3': 'Individuelle Rechnungen',
    'gym.allFeatures6Item4': 'Ratenzahlungsunterstützung',
    'gym.allFeatures6Item5': 'Bis zu 3 Mahnstufen',
    'gym.allFeatures6Item6': 'Manuelle Zahlungserfassung',
    'gym.allFeatures6Item7': 'Änderbare/neu ausstellbare Rechnungen',
    'gym.allFeatures6Item8': 'QR-Rechnungen für Schweizer Banken',
    'gym.allFeatures6Item9': 'Abrechnung nach Tarif 595',
    'gym.allFeatures7Title': 'Dokumentenverwaltung',
    'gym.allFeatures7Item1': 'Automatische Dokumentenerstellung',
    'gym.allFeatures7Item2': 'Individuelle Uploads',
    'gym.allFeatures7Item3': 'Generierung aus Vorlagen',
    'gym.allFeatures7Item4': 'PDF/JPG/PNG Vorschau',
    'gym.allFeatures8Title': 'Automatischer Bankabgleich',
    'gym.allFeatures8Item1': 'CAMT-Datei-Upload',
    'gym.allFeatures8Item2': 'Automatische Zahlungszuordnung per Referenznummer',
    'gym.allFeatures8Item3': 'Eliminiert manuelle Arbeit',
    'gym.allFeatures9Title': '24/7 Zutrittskontrolle',
    'gym.allFeatures9Item1': 'Digitale Mitgliedskarten',
    'gym.allFeatures9Item2': 'Automatische Anwesenheitserfassung',
    'gym.allFeatures9Item3': 'Integration mit Zutrittssystemen',
    'gym.allFeatures9Item4': 'Ideal für 24-Stunden-Studiobetrieb',
    'gym.tarif595FaqTitle': 'Tarif 595 FAQ',
    'gym.tarif595FaqSubtitle': 'Die wichtigsten Antworten zum neuen Rechnungsstandard für Schweizer Fitnessstudios.',
    'gym.tarif595FeaturedQuestion': 'Brauche ich externe Software für Tarif-595-Belege?',
    'gym.tarif595FeaturedAnswer': 'Nein. Die Belege werden direkt in der Initso Gym Software erstellt - ohne Medienbruch.',
    'gym.tarif595Faq1Question': 'Was ändert sich für Sie?',
    'gym.tarif595Faq1Answer': 'Ab dem 1. Januar 2027 werden gesundheitsfördernde Leistungen im Fitnessbereich nach Tarif 595 mit einem einheitlichen Rückforderungsbeleg durch die Versicherung geprüft. Statt den bisherigen Bestätigungen benötigen Ihre Mitglieder künftig einen standardisierten Beleg, der die Pflichtangaben nach dem Schema des Tarifs 595 korrekt enthält.',
    'gym.tarif595Faq2Question': 'Was ist der Tarif 595?',
    'gym.tarif595Faq2Answer': 'Tarif 595 ist ein schweizweit verwendeter Tarif für ambulante gesundheitsfördernde Leistungen im Bereich der Zusatzversicherung. Ab 2027 wird er für Fitnessstudios und ähnliche Anbieter relevant, damit Leistungen strukturiert und nachvollziehbar gegenüber Krankenversicherungen eingereicht werden können.',
    'gym.tarif595Faq5Question': 'Wie kann ich den Tarif im INITSO Gym System nutzen?',
    'gym.tarif595Faq5Answer': 'INITSO integriert diese Funktion in die Gym Software und erstellt automatisch einen Tarif-595-Beleg, welcher dem Kunden direkt aus dem INITSO System gesendet werden kann.',
    'gym.tarif595Faq6Question': 'Ab wann steht die Tarif-595-Funktion zur Verfügung?',
    'gym.tarif595Faq6Answer': 'Die Erstellung von Rückforderungsbelegen nach Tarif 595 wird ab 01.01.2027 automatisch im System freigeschaltet. So können Studios den neuen Standard nutzen, sobald er verbindlich wird.',
    'gym.tarif595Faq7Question': 'Was passiert mit den bisherigen Abo- und Teilnahmebestätigungen?',
    'gym.tarif595Faq7Answer': 'Bisherige Teilnahmebestätigungen reichen ab 2027 für die Abrechnung mit Krankenversicherungen nicht mehr aus. Stattdessen muss der Rückforderungsbeleg nach Tarif 595 verwendet werden.',
    'gym.tarif595Faq8Question': 'Wie kann ich mehr über die INITSO Gym und den Tarif-595 erfahren?',
    'gym.tarif595Faq8Answer': 'Füllen Sie das untenstehende Kontaktformular aus, um eine kostenlose Beratung zu erhalten.',
    // Product Detail Pages - PropertyProfi
    'property.title': 'PropertyProfi',
    'property.subtitle': 'Liegenschaftsverwaltung leicht gemacht. Mit unserem Cloud-basierten Tool haben Sie alle Infos strukturiert zur Verfügung und alle Ihre Aufgaben unter Kontrolle.',
    'property.mainFeatures': 'Hauptfunktionen',
    'property.featuresDescription': 'PropertyProfi bietet Ihnen alle Werkzeuge, die Sie für eine effiziente Liegenschaftsverwaltung benötigen.',
    'property.crmSystem': 'CRM System',
    'property.crmSystemDesc': 'Verwalten Sie alle Ihre Kunden, Mieter und Geschäftspartner zentral an einem Ort mit umfassenden Kontaktinformationen und Kommunikationshistorie.',
    'property.propertyManagement': 'Liegenschaftsverwaltung',
    'property.propertyManagementDesc': 'Organisieren Sie alle Ihre Immobilien strukturiert mit detaillierten Informationen zu Objekten, Einheiten und Mietverhältnissen.',
    'property.accounting': 'Buchhaltung',
    'property.accountingDesc': 'Integrierte Buchhaltungsfunktionen für eine nahtlose Verwaltung aller finanziellen Aspekte Ihrer Liegenschaften.',
    'property.documentArchive': 'Dokumentenarchiv',
    'property.documentArchiveDesc': 'Sichere Aufbewahrung aller wichtigen Dokumente mit intelligenter Kategorisierung und schneller Suchfunktion.',
    'property.insuranceManagement': 'Versicherungsmanagement',
    'property.insuranceManagementDesc': 'Übersichtliche Verwaltung aller Versicherungen mit automatischen Erinnerungen für Verlängerungen und Zahlungen.',
    'property.reportingAnalytics': 'Reporting & Analytics',
    'property.reportingAnalyticsDesc': 'Umfassende Berichte und Analysen zur Rentabilität und Performance Ihrer Immobilienportfolios.',
    'property.showcaseTitle': 'PropertyProfi in Aktion',
    'property.showcase1Title': 'Dashboard-Übersicht',
    'property.showcase1Desc': 'Zentrale Übersicht über alle Ihre Liegenschaften mit wichtigen Kennzahlen und aktuellen Aktivitäten auf einen Blick.',
    'property.showcase2Title': 'Finanzmanagement',
    'property.showcase2Desc': 'Umfassende Buchhaltungsfunktionen für die Verwaltung aller finanziellen Aspekte Ihrer Immobilienportfolios.',
    'property.showcase3Title': 'Dokumentenverwaltung',
    'property.showcase3Desc': 'Sichere und organisierte Aufbewahrung aller wichtigen Dokumente mit intelligenter Suchfunktion.',
    'property.whyPropertyProfi': 'Warum PropertyProfi?',
    'property.cloudBased': 'Cloud-basiert',
    'property.cloudBasedDesc': 'Zugriff von überall und jederzeit auf Ihre Daten - sicher und zuverlässig.',
    'property.userFriendly': 'Benutzerfreundlich',
    'property.userFriendlyDesc': 'Intuitive Bedienung ohne lange Einarbeitungszeit - sofort einsatzbereit.',
    'property.scalable': 'Skalierbar',
    'property.scalableDesc': 'Wächst mit Ihrem Unternehmen - von einzelnen Objekten bis zu grossen Portfolios.',
    'property.swissQuality': 'Schweizer Qualität',
    'property.swissQualityDesc': 'Entwickelt in der Schweiz nach höchsten Datenschutz- und Sicherheitsstandards.',
    'property.readyForPropertyProfi': 'Bereit für PropertyProfi?',
    'property.readyForPropertyProfiDesc': 'Kontaktieren Sie uns für eine persönliche Demonstration und erfahren Sie, wie PropertyProfi Ihre Liegenschaftsverwaltung revolutionieren kann.',
    'property.contactNow': 'Jetzt Kontakt aufnehmen',
    // Product Detail Pages - Web
    'web.title': 'Webseiten & Webshops',
    'web.subtitle': 'Ihre Daten, Ihr Erfolg – Entfesseln Sie Ihr Potenzial. Kreative Webdesign-Experten, effizientes Datenmanagement und nahtlose Integration.',
    'web.ourWebServices': 'Unsere Web-Services',
    'web.webServicesDesc': 'Von der kreativen Gestaltung bis zur technischen Umsetzung - wir bieten Ihnen alles für Ihren erfolgreichen Webauftritt.',
    'web.creativeWebDesign': 'Kreatives Webdesign',
    'web.creativeWebDesignDesc': 'Individuelle und ansprechende Designs, die Ihre Marke perfekt widerspiegeln und Ihre Zielgruppe begeistern.',
    'web.customSolutions': 'Massgeschneiderte Lösungen',
    'web.customSolutionsDesc': 'Jede Website wird speziell für Ihre Anforderungen entwickelt - keine Templates, sondern echte Individualität.',
    'web.efficientDataManagement': 'Effizientes Datenmanagement',
    'web.efficientDataManagementDesc': 'Intelligente Datenstrukturen und Content Management Systeme für einfache Verwaltung Ihrer Inhalte.',
    'web.apiConnections': 'API Anbindungen',
    'web.apiConnectionsDesc': 'Nahtlose Integration von Drittsystemen und Bezahlsystemen für erweiterte Funktionalität Ihrer Website.',
    'web.responsiveDesign': 'Responsive Design',
    'web.responsiveDesignDesc': 'Perfekte Darstellung auf allen Geräten - von Desktop bis Smartphone für optimale Benutzererfahrung.',
    'web.ecommerceIntegration': 'E-Commerce Integration',
    'web.ecommerceIntegrationDesc': 'Vollständige Webshop-Lösungen mit sicheren Bezahlsystemen und Lagerverwaltung für Ihren Online-Erfolg.',
    'web.showcaseTitle': 'Unsere Web-Projekte',
    'web.showcase1Title': 'Responsive Webdesign',
    'web.showcase1Desc': 'Moderne, responsive Websites die auf allen Geräten perfekt funktionieren - von Desktop bis Smartphone.',
    'web.showcase2Title': 'E-Commerce Lösungen',
    'web.showcase2Desc': 'Professionelle Webshop-Entwicklung mit sicheren Bezahlsystemen und umfassender Produktverwaltung.',
    'web.showcase3Title': 'Datenvisualisierung',
    'web.showcase3Desc': 'Interaktive Dashboards und Berichte für eine übersichtliche Darstellung Ihrer Geschäftsdaten.',
    'web.ourDevelopmentProcess': 'Unser Entwicklungsprozess',
    'web.needsAnalysis': 'Bedarfsanalyse',
    'web.needsAnalysisDesc': 'Wir analysieren Ihre Anforderungen und entwickeln gemeinsam mit Ihnen das optimale Konzept.',
    'web.designPrototyping': 'Design & Prototyping',
    'web.designPrototypingDesc': 'Erstellung von Mockups und Prototypen für eine klare Vorstellung des Endresultats.',
    'web.development': 'Entwicklung',
    'web.developmentDesc': 'Professionelle Umsetzung mit modernsten Technologien und höchsten Qualitätsstandards.',
    'web.launchSupport': 'Launch & Support',
    'web.launchSupportDesc': 'Erfolgreicher Go-Live mit anschließendem Support und kontinuierlicher Betreuung.',
    'web.readyForNewWebPresence': 'Bereit für Ihren neuen Webauftritt?',
    'web.readyForNewWebPresenceDesc': 'Lassen Sie uns gemeinsam Ihre Vision verwirklichen. Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch.',
    'web.discussProject': 'Projekt besprechen',
    // Product Detail Pages - Portal
    'portal.title': 'Kundenportal',
    'portal.subtitle': 'Alle Abschlüsse Ihrer Betriebspartner und die Bestellungen der Kunden in einem übersichtlichen, sicheren Cloud Tool.',
    'portal.portalFeatures': 'Portal-Funktionen',
    'portal.portalFeaturesDesc': 'Unser Kundenportal bietet eine zentrale Plattform für alle Ihre Geschäftsprozesse und Kundeninteraktionen.',
    'portal.efficientApplicationProcessing': 'Effiziente Antragsbearbeitung',
    'portal.efficientApplicationProcessingDesc': 'Streamlinen Sie Ihre Antragsverarbeitung mit automatisierten Workflows und digitalem Dokumentenmanagement.',
    'portal.dataVisualization': 'Datenvisualisierung',
    'portal.dataVisualizationDesc': 'Intelligente Dashboards und Berichte für bessere Geschäftsentscheidungen basierend auf Echtzeitdaten.',
    'portal.competentCustomerService': 'Kompetente Kundenbetreuung',
    'portal.competentCustomerServiceDesc': 'Integrierte Kommunikationstools und Ticketsystem für erstklassigen Kundenservice und Support.',
    'portal.increaseProductivity': 'Produktivität steigern',
    'portal.increaseProductivityDesc': 'Automatisierung wiederkehrender Aufgaben und optimierte Workflows für maximale Effizienz.',
    'portal.secureDataProcessing': 'Sichere Datenverarbeitung',
    'portal.secureDataProcessingDesc': 'Höchste Sicherheitsstandards und Datenschutz-Compliance für vertrauensvolle Geschäftsbeziehungen.',
    'portal.userFriendlyInterface': 'Benutzerfreundliche Oberfläche',
    'portal.userFriendlyInterfaceDesc': 'Intuitive Bedienung und personalisierbare Dashboards für eine optimale Benutzererfahrung.',
    'portal.showcaseTitle': 'Portal-Features im Detail',
    'portal.showcase1Title': 'Benutzer-Dashboard',
    'portal.showcase1Desc': 'Intuitive Benutzeroberfläche mit personalisierbaren Dashboards für optimale Benutzererfahrung.',
    'portal.showcase2Title': 'Workflow-Management',
    'portal.showcase2Desc': 'Automatisierte Prozesse und effiziente Workflow-Verwaltung für maximale Produktivität.',
    'portal.showcase3Title': 'Sichere Datenverarbeitung',
    'portal.showcase3Desc': 'Höchste Sicherheitsstandards und DSGVO-konforme Datenverarbeitung für vertrauensvolle Zusammenarbeit.',
    'portal.advantagesOfOurPortal': 'Vorteile unseres Portals',
    'portal.centralizedManagement': 'Zentralisierte Verwaltung',
    'portal.centralizedManagementDesc': 'Alle Ihre Geschäftsprozesse an einem Ort - übersichtlich und effizient verwaltet.',
    'portal.realtimeSynchronization': 'Echtzeit-Synchronisation',
    'portal.realtimeSynchronizationDesc': 'Alle Daten werden in Echtzeit synchronisiert für konsistente und aktuelle Informationen.',
    'portal.scalableArchitecture': 'Skalierbare Architektur',
    'portal.scalableArchitectureDesc': 'Das Portal wächst mit Ihrem Unternehmen und passt sich Ihren Anforderungen an.',
    'portal.customizableWorkflows': 'Anpassbare Workflows',
    'portal.customizableWorkflowsDesc': 'Konfigurieren Sie Prozesse nach Ihren spezifischen Geschäftsanforderungen.',
    'portal.readyForYourOwnPortal': 'Bereit für Ihr eigenes Portal?',
    'portal.readyForYourOwnPortalDesc': 'Erfahren Sie, wie unser Kundenportal Ihre Geschäftsprozesse revolutionieren und Ihre Produktivität steigern kann.',
    'portal.requestPortalDemo': 'Portal-Demo anfordern',
    // Contact Form
    'contactForm.title': 'Kontakt aufnehmen',
    'contactForm.description': 'Haben Sie Fragen zu {productName}? Kontaktieren Sie uns für weitere Informationen oder eine persönliche Beratung.',
    'contactForm.yourInquiry': 'Ihre Anfrage zu {productName}',
    'contactForm.name': 'Name *',
    'contactForm.email': 'E-Mail *',
    'contactForm.message': 'Nachricht *',
    'contactForm.messagePlaceholder': 'Ich interessiere mich für {productName} und hätte gerne weitere Informationen...',
    'contactForm.sendMessage': 'Nachricht senden',
    'contactForm.sending': 'Wird gesendet...',
    'contactForm.messageSent': 'Nachricht gesendet',
    'contactForm.thankYou': 'Vielen Dank für Ihre Anfrage. Wir melden uns bald bei Ihnen!',
    'contactForm.error': 'Fehler',
    'contactForm.errorMessage': 'Beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  // Blog
  'blog.title': 'Blog',
  'blog.subtitle': 'Einblicke, Praxiswissen und Neuigkeiten rund um Software, Digitalisierung und INITSO.',
  'blog.loading': 'Beiträge werden geladen',
  'blog.loadError': 'Die Beiträge konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
  'blog.unavailable': 'Blog nicht verfügbar',
  'blog.empty': 'Noch keine Beiträge veröffentlicht',
  'blog.readMore': 'Beitrag lesen',
  'blog.pagination': 'Blog-Seiten',
  'blog.previous': 'Vorherige Seite',
  'blog.next': 'Nächste Seite',
  'blog.backToOverview': 'Zurück zum Blog',
  'blog.notFoundTitle': 'Beitrag nicht gefunden',
  'blog.notFoundDescription': 'Der gesuchte Beitrag existiert nicht oder wurde entfernt.',
  // Buttons
  'buttons.login': 'Login',
  'buttons.startTrial': 'Start Trial',
  // Team Roles
  'CEO': 'CEO',
  'CFO': 'CFO',
  'Chief Software Developer': 'Chief Software Developer',
  'Chief Software Architect': 'Chief Software Architect',
  'Head Frontend Entwickler': 'Head Frontend Entwickler',
  'Q&I Developer': 'Q&I Developer',
  'Sales & Marketing': 'Sales & Marketing'
} as const;
